import React, { createRef } from 'react';
import PropTypes from 'prop-types';
import * as locales from 'react-date-range/dist/locale';

// 캘린더
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { Calendar } from 'react-date-range';
import { DateRangePicker } from 'react-date-range';
import { addDays } from 'date-fns';
import moment from 'moment';

class Forms extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            startDate: moment().format('YYYY.MM.DD'),
            endDate: moment().add(7, 'days').format('YYYY.MM.DD'),
            newStartDate: moment().format('YYYY.MM.DD'),
            newEndDate: moment().add(7, 'days').format('YYYY.MM.DD'),
            showCalendar: false,
        };

        if (props.from) {
            this.state.startDate = this.props.from.substr(0, 10);
            this.state.newStartDate = this.props.from.substr(0, 10);
        }
        if (props.to) {
            this.state.endDate = this.props.to.substr(0, 10);
            this.state.newEndDate = this.props.to.substr(0, 10);
        }
    }

    clickCalendarLeft = e => {
        const newGap = moment.duration(moment(this.state.newEndDate).diff(moment(this.state.newStartDate))).asDays() + 1;

        const newStartDate = moment(this.state.newStartDate, 'YYYY.MM.DD')
            .add(newGap * -1, 'days')
            .format('YYYY.MM.DD');
        const newEndDate = moment(this.state.newEndDate, 'YYYY.MM.DD')
            .add(newGap * -1, 'days')
            .format('YYYY.MM.DD');

        this.setState({
            startDate: newStartDate,
            endDate: newEndDate,
            newStartDate,
            newEndDate,
            showCalendar: false,
        });

        if (this.props.onChange !== undefined) {
            this.props.onChange(newStartDate, newEndDate);
        }
    };

    clickCalendarRight = e => {
        const newGap = moment.duration(moment(this.state.newEndDate, 'YYYY.MM.DD').diff(moment(this.state.newStartDate, 'YYYY.MM.DD'))).asDays() + 1;

        const newStartDate = moment(this.state.newStartDate, 'YYYY.MM.DD').add(newGap, 'days').format('YYYY.MM.DD');
        const newEndDate = moment(this.state.newEndDate, 'YYYY.MM.DD').add(newGap, 'days').format('YYYY.MM.DD');

        this.setState({
            startDate: newStartDate,
            endDate: newEndDate,
            newStartDate,
            newEndDate,
            showCalendar: false,
        });

        if (this.props.onChange !== undefined) {
            this.props.onChange(newStartDate, newEndDate);
        }
    };

    /**
     * 날짜 선택
     * @param {*} date
     */
    handleSelect = date => {
        this.setState({
            newStartDate: moment(date.range1.startDate).format('YYYY.MM.DD'),
            newEndDate: moment(date.range1.endDate).format('YYYY.MM.DD'),
        });
    };

    /**
     * 적용
     * @param {*} e
     */
    clickSave = e => {
        this.setState({
            startDate: this.state.newStartDate,
            endDate: this.state.newEndDate,
            showCalendar: false,
        });

        if (this.props.onChange !== undefined) {
            this.props.onChange(this.state.newStartDate, this.state.newEndDate);
        }
    };

    /**
     * 취소
     * @param {*} e
     */
    clickCancel = e => {
        this.setState({
            newStartDate: this.state.startDate,
            newEndDate: this.state.endDate,
            showCalendar: false,
        });
    };

    render() {
        // 달력 범위 선택
        const selectionRange = {
            startDate: moment(this.state.newStartDate, 'YYYY.MM.DD').toDate(),
            endDate: moment(this.state.newEndDate, 'YYYY.MM.DD').toDate(),
            // key: "selection"
        };

        const newGap = moment.duration(moment(this.state.newEndDate).diff(moment(this.state.newStartDate))).asDays() + 1;
        const gap = moment.duration(moment(this.state.endDate).diff(moment(this.state.startDate))).asDays() + 1;

        const orientation = window.matchMedia('(max-width: 700px)').matches ? 'vertical' : 'horizontal';

        return (
            <div className="date_picker_top_btn_wrap">
                <div className="date_picker_top_btn">
                    <button className="btn_arrow" onClick={this.clickCalendarLeft}>
                        <i className="xi-angle-left" />
                    </button>
                    <div
                        className="mid_cale_box"
                        onClick={e => {
                            this.setState({ showCalendar: !this.state.showCalendar });
                        }}
                    >
                        <i className="xi-calendar" /> {this.state.startDate} ~ {this.state.endDate} {/*({gap}일)*/}
                    </div>
                    <button className="btn_arrow" onClick={this.clickCalendarRight}>
                        <i className="xi-angle-right" />
                    </button>
                </div>
                {this.state.showCalendar && (
                    <div className="date_picker_top_popUp" style={this.props.align === 'right' ? { right: 0 } : {}}>
                        <ul className="date_list">
                            {/* <li className="active">
                                <a href="javascript:;">지난 14일</a>
                            </li> */}
                            <li>
                                <a
                                    href="javascript:;"
                                    onClick={e => {
                                        this.setState({
                                            newStartDate: moment().add(-1, 'days').format('YYYY.MM.DD'),
                                            newEndDate: moment().format('YYYY.MM.DD'),
                                        });
                                    }}
                                >
                                    어제
                                </a>
                            </li>
                            <li>
                                <a
                                    href="javascript:;"
                                    onClick={e => {
                                        this.setState({
                                            newStartDate: moment().add(-7, 'days').format('YYYY.MM.DD'),
                                            newEndDate: moment().format('YYYY.MM.DD'),
                                        });
                                    }}
                                >
                                    지난 7일
                                </a>
                            </li>
                            <li>
                                <a
                                    href="javascript:;"
                                    onClick={e => {
                                        this.setState({
                                            newStartDate: moment().add(-14, 'days').format('YYYY.MM.DD'),
                                            newEndDate: moment().format('YYYY.MM.DD'),
                                        });
                                    }}
                                >
                                    지난 14일
                                </a>
                            </li>
                            <li>
                                <a
                                    href="javascript:;"
                                    onClick={e => {
                                        this.setState({
                                            newStartDate: moment().startOf('week').add(-7, 'days').format('YYYY.MM.DD'),
                                            newEndDate: moment().startOf('week').add(-1, 'days').format('YYYY.MM.DD'),
                                        });
                                    }}
                                >
                                    지난 주
                                </a>
                            </li>
                            <li>
                                <a
                                    href="javascript:;"
                                    onClick={e => {
                                        this.setState({
                                            newStartDate: moment().startOf('month').add(-1, 'month').format('YYYY.MM.DD'),
                                            newEndDate: moment().startOf('month').add(-1, 'days').format('YYYY.MM.DD'),
                                        });
                                    }}
                                >
                                    지난 달
                                </a>
                            </li>
                            <li>
                                <a
                                    href="javascript:;"
                                    onClick={e => {
                                        this.setState({
                                            newStartDate: moment().startOf('week').format('YYYY.MM.DD'),
                                            newEndDate: moment().format('YYYY.MM.DD'),
                                        });
                                    }}
                                >
                                    이번 주
                                </a>
                            </li>
                            <li>
                                <a
                                    href="javascript:;"
                                    onClick={e => {
                                        this.setState({
                                            newStartDate: moment().startOf('month').format('YYYY.MM.DD'),
                                            newEndDate: moment().format('YYYY.MM.DD'),
                                        });
                                    }}
                                >
                                    이번 달
                                </a>
                            </li>
                        </ul>
                        <div className="date_box">
                            <DateRangePicker
                                showDateDisplay={false}
                                ranges={[selectionRange]}
                                months={2}
                                locale={locales['ko']}
                                direction={orientation}
                                onChange={this.handleSelect}
                            />
                        </div>
                        <div className="bott_box">
                            <div className="lb">
                                {this.state.newStartDate} ~ {this.state.newEndDate} ({newGap}일)
                            </div>
                            <div className="rb">
                                <button className="btn_nor01 purple" onClick={this.clickSave}>
                                    적용
                                </button>
                                <button className="btn_nor01 pur_line" onClick={this.clickCancel}>
                                    취소
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

Forms.defaultProps = {
    title: '',
    value: '',
    placeholder: '',
    disabled: false,
    show_name: false,
    btn_name: '업로드',
};

Forms.propTypes = {
    title: PropTypes.string,
    type: PropTypes.string,
    placeholder: PropTypes.string,
};

export default Forms;
